export default __webpack_public_path__ + "static/media/Seccion_promos_activaMobile_18_Septiembre.4bdb9191.webp";